import domReady from '@wordpress/dom-ready';

domReady(() => {
  const videos = document.querySelectorAll('.card-podcast__video');

  if (0 < videos.length) {
    videos.forEach((video) => {
      let previewTimeout = null;

      video.addEventListener('mouseenter', () => {
        startPreview(video);
        previewTimeout = setTimeout(stopPreview, 4000);
      });

      video.addEventListener('mouseleave', () => {
        clearTimeout(previewTimeout);
        previewTimeout = null;
        stopPreview(video);
      });
    });
  }
});

function startPreview(video) {
  video.muted = true;
  video.currentTime = 1;
  video.playbackRate = 0.5;
  video.play();
}

function stopPreview(video) {
  video.currentTime = 0;
  video.playbackRate = 1;
  video.pause();
}
